import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateDecimal'
})
export class TruncateDecimalPipe implements PipeTransform {
  transform(value: number, decimals: number = 1): string {
    if (typeof value !== 'number' || isNaN(value)) return '';
    const factor = Math.pow(10, decimals);
    return (Math.trunc(value * factor) / factor).toFixed(decimals);
  }
} 